import { FC } from 'react'
import Image from 'next/image'
import classNames from 'classnames'
import Slider from 'react-slick'
import parse from 'html-react-parser'
import { useTranslation } from 'next-i18next'
import { isWeekend } from 'date-fns'
import { ContactCTAProps as Props } from './types'
import styles from './ContactCTA.module.scss'
import { DESK_IMAGES } from './constants'

const ContactCTA: FC<Props> = ({ avatar, className, description, hasDarkBg, title }) => {
  // i18n
  const { t } = useTranslation(['faqIncreaseInstallment', 'lookingForHelp'])

  // Support availability
  const today = new Date()
  const available = isWeekend(today) === false

  return (
    <section className={classNames('section', styles.contact, { 'is-dark': hasDarkBg }, className)}>
      <div className="container">
        <div className={styles['contact-card']}>
          <div className={styles['image-background']}>
            <div className={styles['image-container']}>
              {avatar ? (
                <Image className={styles.image} priority src={avatar} layout="fill" objectFit="cover" alt="" quality={100} />
              ) : (
                <Slider
                  slidesToShow={1}
                  fade
                  dots={false}
                  infinite
                  autoplay
                  arrows={false}
                  autoplaySpeed={4000}
                  speed={1000}
                  draggable={false}
                  pauseOnHover={false}
                >
                  {DESK_IMAGES.map((imageUrl) => {
                    return (
                      <Image
                        key={imageUrl}
                        priority
                        src={imageUrl}
                        layout="fill"
                        objectFit="cover"
                        alt="Bolt Energie support"
                        quality={100}
                        className={styles.image}
                      />
                    )
                  })}
                </Slider>
              )}
            </div>
          </div>
          <div className={styles.content}>
            <h2>{parse(title)}</h2>
            <p>{parse(description)}</p>
            <p className={styles['with-links']}>
              {parse(
                t(
                  'contact.links',
                  '<a href="tel:028993300">02 899 33 00</a> of <a href="mailto:hallo@boltenergie.be">hallo@boltenergie.be</a>'
                )
              )}
            </p>
            <p className={styles.posttext}>
              {available
                ? t('lookingForHelp:available', 'We zijn vandaag bereikbaar tot 18:00')
                : t('lookingForHelp:unavailable', 'We zijn maandag bereikbaar vanaf 9:00')}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

ContactCTA.defaultProps = {
  hasDarkBg: false
}

export default ContactCTA
